import { apiUrl, herokuUrl } from "./config.json";
import httpService from "./httpService";
let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = apiUrl + "/users";
} else {
  apiEndpoint = herokuUrl + "/users";
}

export async function register(user) {
  const response = await httpService.post(`${apiEndpoint}/`, user);
  console.log(response);
  return response;
}
export async function resendEmail(email, actual) {
  
  const response = await httpService.post(
    `${apiEndpoint}/resendConfirmation`,
    {
      email: email,
      actual: actual
    }
  );
  console.log(response);
  return response;
}

export async function getTeam() {
  let data = await httpService.get(`${apiEndpoint}/getTeamMembers`);
  console.log(data);
  return data;
}

export async function getUserProfile(email) {
  let data = await httpService.get(`${apiEndpoint}/getUserProfile/${email}`);
  // console.log(data);
  return data;
}

export async function getProfile() {
  let data = await httpService.get(`${apiEndpoint}/getProfile`);
  // console.log(data);
  return data;
}


export async function getProfile2(id) {
  let data = await httpService.post(`${apiEndpoint}/getProfile2`,{id});
  // console.log(data);
  return data;
}

export async function updateProfile(data) {
  let user = await httpService.post(`${apiEndpoint}/updateProfile`, data);
  console.log(user);
  return user;
}


export async function deleteAccount() {
  // console.log(sessionStorage.getItem('token'));
  let token = await sessionStorage.getItem("currentUserEmail");
  let user = await httpService.post(`${apiEndpoint}/deleteAccount`, {
    token: token
  });
  console.log(user);
  return user;
}

export async function deleteTeam(data) {
  const team = await httpService.post(`${apiEndpoint}/deleteTeamMembers`, data);
  console.log(team);
  return team;
}

export async function getExpiryDate() {
  let data = await httpService.get(`${apiEndpoint}/getExpiryDate`);
  return data;
}


export async function submitContactForm(data) {
  let response = await httpService.post(`${apiEndpoint}/sendForm`,data);
  return response;
}

export async function addUserToTeam(data) {
  console.log('addUserToTeam',data);
  let response = await httpService.post(`${apiEndpoint}/addToTeam`,data);
  return response;
}
export async function getuserdata(data) {
  console.log('addUserToTeam',data);
  let response = await httpService.post(`${apiEndpoint}/getuserdata`,{data});

  return response;
}

export async function updateuserdata(data) {
  let response = await httpService.post(`${apiEndpoint}/updateUserRole`,{data});

  return response;
}


export async function getuserdataByOrgid(data) {
  console.log('addUserToTeam',data);
  let response = await httpService.post(`${apiEndpoint}/getRoleByOrgid`,{data});

  return response;
}


export async function sendInvitation(data) {
  let response = await httpService.post(`${apiEndpoint}/sendInviteLink`,{data});
  return response;
}

export async function getUsersByOrgId(data) {
  let response = await httpService.post(`${apiEndpoint}/getUsersByOrgId`,{data});
  return response;
}


export async function sendQuestions(data) {
  let response = await httpService.post(`${apiEndpoint}/sendQuestions`,data);
  return response;
}

export default {
 
  register,
  getTeam,
  getUserProfile,
  getProfile,
  updateProfile,
  // OTPRequest,
  deleteTeam,
  deleteAccount,
  getExpiryDate,
  resendEmail,
  addUserToTeam,
  getuserdata,
  getuserdataByOrgid,
  updateuserdata
};
